import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/landingpages/dj-set1/Video.mp4")